import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { COLORS } from '../../styles/colors';
import VideoPreviewButton from '../VideoPreviewButton';
import { faCopy } from '@fortawesome/free-solid-svg-icons'

const SandboxPlanItem = ({item, remove, copyItem, edit}) => {
  const formData = item.formData;
  const chips = Object.keys(formData).map((field,k) => {
    const key = `${field}-${k}`;
    const { repsToFailure, pyramidReps, unit, qty, rest, rounds, tempo } = formData;
    switch (field) {
      case 'repsToFailure':
        return !!repsToFailure && <span key={key}>{`reps to failure | `}</span>;
      case 'unit':
        if (pyramidReps && !repsToFailure) {
          let reps = '';
          let value = '';
          if (typeof pyramidReps === 'string') {
            reps = pyramidReps.split(',');
            value = reps.map(r => `(${r}) `).join(' ');
          } else if (Array.isArray(pyramidReps)) {
            reps = pyramidReps.filter(r => r);
            value = reps.map(r => `(${r}) `).toString();
          }
          if (value) return <span key={key}>{`pyramid ${unit} ${value} | `}</span>;
          else if (!!qty) return <span key={key}>{`${qty} ${unit} | `}</span>;
          return null;
        } else {
          return (
            !repsToFailure && !!qty && <span key={key}>{`${qty} ${unit} | `}</span>
          )
        }
      case 'sets':
        if (!item.inCircuit) {
          return (
            <span key={key}>{`${formData[field]} X `}</span>
          )
        }
        break;
      case 'eachSide':
        if (formData[field]) {
          return (
            <span key={key}>{`each side | `}</span>
          )
        }
        break;
      case 'rm':
        if (formData[field]) {
          return (
            <span key={key}>{`${formData[field]}% 1RM | `}</span>
          )
        }
        break;
      case 'wp':
        if (formData[field]) {
          return (
            <span key={key}>{`${formData[field]} lbs. | `}</span>
          )
        }
        break;
      case 'rpe':
        if (formData[field]) {
          return (
            <span key={key}>{`${formData[field]} RPE | `}</span>
          )
        }
        break;
      case 'tempo':
        if (tempo) {
          let data = '';
          let value = '';
          if (typeof tempo === 'string') {
            data = tempo.split(',');
            value = data.map(t => `(${t})`).join(' ');
          } else {
            data = tempo.filter(r => r);
            value = data.map(r => `(${r}) `).toString();
          }
          if (value) return <span key={key}>{`${field} ${value} | `}</span>;
        }
        break;
      case 'rest':
        const restLabel = rest === null ? 'rest as needed' : `${rest} sec. rest`;
        return (
          <span key={key}>{restLabel}</span>
        )
      case 'amrp':
        if (formData['amrp']) {
          return (
            <span key={key}>{"As Many Rounds As Possible;"}</span>
          )
        }
        break;
      case 'rounds':
        if (formData['rounds']) {
          return (
            <span key={key}>{`${rounds} rounds;`}</span>
          )
        }
        break;
      default:
        break;
    }
    return null;
  });
  return (
    <div style={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      background: COLORS.white,
      padding: '5px 0'
        // height: 55,
        // borderBottom: '1px solid ' + COLORS.grey,
        // borderTop: '1px solid ' + COLORS.grey
      }}>
      <FontAwesomeIcon icon="grip-vertical"
        style={{width: '5%', marginRight: 5, color: COLORS.grey}}/>

      <div style={{width: '80%'}}>
        <b>{item.content}</b>
        <br />
          { chips }
      </div>

      <VideoPreviewButton 
         videoUrl={item.data.videoUrl} 
         title={item.data.title} 
         user = {{}}
         autoplay loop muted />

     <FontAwesomeIcon icon="times" className="link"
        onClick={remove}
        style={{width: '5%', color: COLORS.orange}}/>

      
      <FontAwesomeIcon icon={faCopy} className="link"
        onClick={copyItem}
        style={{width: '5%', color: COLORS.orange}}/>

      <FontAwesomeIcon icon="edit" className="link"
        onClick={edit}
        style={{width: '5%', color: COLORS.orange}}/>
    </div>
  )
}

export default SandboxPlanItem;



// WEBPACK FOOTER //
// ./src/components/workouts/SandboxPlanItem.js